import { useStore } from 'vuex'
import { ref, computed } from 'vue'

import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";

export default {
    name: "UploadNewFileOverlay",
    setup(){
        const store = useStore()
        const file = ref({})

        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)

        let displayError = ref(false)

        const onFileChange = (e) => {
            displayError.value = false;

            const uploadedFiles = e.target.files 
            let newFile = {}
    
            Array.from(uploadedFiles).forEach(uploadedfile => {
                newFile.value = uploadedfile
                newFile.value.url = URL.createObjectURL(uploadedfile)
                file.value = newFile.value
            })

            setTimeout( ()=> {
                const deleteButton = document.querySelector('.kb-js--delete-uploaded-file-card')
                deleteButton.focus()
            } , 100)
     
        }

        const removeFile = () => {
                file.value = {}
        }

        // TODO: how to we validate files ? BE job?
        const isFormValid = () => {
            let fileTypeToStringIfPresent = file.value?.type ? file.value.type.toString() : null
            return nonEmptyStringValidator(fileTypeToStringIfPresent) ? true : false
        };

        const submitUploadNewFile = () => {
            const isValid = isFormValid();
            displayError.value = !isValid;

            if (isValid) {
                store.dispatch("frivillige/submitUploadNewFile", {
                    file: file.value
                })
                .then(() => {
                    store.dispatch('main/closePageOverlay')
                    store.dispatch('search/refreshSearches')
                });
            }
        };

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "UploadNewFileOverlay",
                labelKey: labelKey,
            });

        return {
            file,
            isSubmitting,
            displayError,
            getLabel,
            onFileChange,
            removeFile,
            submitUploadNewFile
        }
    }
}